@if (apiLoading$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}
<form [formGroup]="form">

  @if(!usjCode){
    <table class="table" style="width: 100%">
      <caption class="cx-visually-hidden">
        {{
        'cartItems.caption' | cxTranslate
        }}
      </caption>
      @if (hasHeader) {
        <thead>
          <tr>
            <th class="cart-table-th">
              {{ 'cartItems.description' | cxTranslate }}
            </th>
            <!-- @if(dateLabelDisplay$ | async){ -->
            <th class="cart-table-th">
              {{ 'cartItems.date' | cxTranslate }}
            </th>
            <!-- } -->
            <th class="cart-table-th">
              {{ 'cartItems.quantity' | cxTranslate }}
            </th>
            @if (displayTicketID) {
              <th class="cart-table-th">
                {{ 'cartItems.ticketID' | cxTranslate }}
              </th>
            }
            @if (displayProductUnitPrice) {
              <th class="cart-table-th">
                {{ 'cartItems.productUnitPrice' | cxTranslate }}
              </th>
            }
            @if (displayProductVariantTotalPrice) {
              <th class="cart-table-th">
                {{ 'cartItems.productVariantTotalPrice' | cxTranslate }}
              </th>
            }
            @if (options.isSaveForLater) {
              <th class="cart-table-th">
                {{ 'saveForLaterItems.stock' | cxTranslate }}
              </th>
            } @else {
              @if(!UDXshowFields){
                @if (displayTotalPriceColumn) {
                  <th class="cart-table-th text-wrap">
                    {{ 'cartItems.total' | cxTranslate }}
                  </th>
                }
              }
            }
            @if (shouldEnableActions()) {
              <th class="cart-table-th">
                {{ 'cartItems.actions' | cxTranslate }}
              </th>
            }
          </tr>
        </thead>
      }
      <tbody class="app-cart-item-list">
        @for (item of items; track item; let i = $index) {
          <tr>
            <td class="cart-table-td">
              <div class="container">
                <!-- Item Image -->
                <div>
                <a [routerLink]="
                    { cxRoute: 'product', params: item.baseProduct ? item.baseProduct : item.product } | cxUrl
                  " tabindex="0">
                    <cx-media [container]="getImageForProduct(item)" format="cartIcon"
                    [alt]="$any(item).baseProduct ? $any(item).baseProduct.name : $any(item).product.name"></cx-media>
                  </a>
                  <div class="cx-info">
                    <div class="cx-name">
                    <a class="cx-link" [routerLink]="
                        { cxRoute: 'product', params: item.baseProduct ? item.baseProduct : item.product } | cxUrl
                      ">{{ item.baseProduct ? item.baseProduct.name : item.product?.name }}</a>
                    </div>
                    <div class="cx-code">
                      {{ 'cartItems.id' | cxTranslate }}
                      {{ item.baseProduct ? item.baseProduct.code : item.product?.code }}
                    </div>
                  </div>
                </div>
              </div>
              @if(item?.errors?.length > 0){
                <div>
                  <span [ngStyle]="{'color':'red','font-weight':'bold'}">
                    {{ item?.errors?.[0]?.message}}
                  </span>
                </div>
              }
            </td>
            <td class="cart-table-td">
              <!-- @if(dateLabelDisplay$ |async){ -->
              <div class="cx-mobile-header-qty" placement="left">
                {{ 'cartItems.date' | cxTranslate }}
              </div>
              <!-- } -->
              <!-- Date -->
              @if(checkDateDisplay(item)){
                <div class="mobile-display-date">
                  @if (item.selectedDateToVisit) {
                    <div class="col">
                      <div class="label-font">
                        @if (!displaycartItemLabel) {
                          {{ 'pdp.selectVisitDateNA' | cxTranslate }}
                        }
                        @if (displaycartItemLabel) {
                          {{ 'pdp.displayVisitDateNA' | cxTranslate }}
                        }
                      </div>
                      @if (readonly) {
                        {{ item.selectedDateToVisit }}
                      }
                      @if (!readonly) {
                        <mat-form-field style="max-width: 150px" appearance="fill">
                          <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="dp" [readonly]="true"
                      [formControl]="
                        $any(form).get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-date')
                      " (dateChange)="dateSelected($event, item)" />
                          <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle(item)"></mat-datepicker-toggle>
                          <mat-datepicker #dp [disabled]="readonly"></mat-datepicker>
                        </mat-form-field>
                        @if (item.isLoadingDates) {
                          <mat-spinner></mat-spinner>
                        }
                      }
                    </div>
                  }
                  @if (item.selectedTimeSlot && item?.product?.timeSelectionRequired) {
                    <div class="col">
                      <div class="label-font">
                        @if (!displaycartItemLabel) {
                          {{ 'pdp.selectVisitTimeNa' | cxTranslate }}
                        }
                        @if (displaycartItemLabel) {
                          {{ 'pdp.displayVisitTimeNa' | cxTranslate }}
                        }
                      </div>
                      @if (readonly) {
                        {{ item.selectedTimeSlot }}
                      }
                      @if (!readonly) {
                        <mat-form-field style="max-width: 150px" appearance="fill">
                          <mat-select placeholder="{{ item.selectedTimeSlot }}"
                      (selectionChange)="timeSlotSelected($event, item)" [formControl]="
                        $any(form.get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-time'))
                      " name="time" [disabled]="readonly" [value]="getDefaultPerfomance(item.timeSlots)">
                            @for (time of item.timeSlots; track time) {
                              <mat-option [value]="time">
                                {{ time }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                  }
                </div>
              }
            </td>
            @if (item.variants) {
              <td class="cart-table-td">
                <div class="cx-mobile-header-price inline-padding" placement="left"
                  title="{{ 'cartItems.quantityTitle' | cxTranslate }}">
                  {{ 'cartItems.quantity' | cxTranslate }}
                </div>
                <!-- Quantity -->
                @for (option of item.variantOptions; track option; let isLast = $last) {
                  <div class="row container mr-0  pr-0 pl-0 mb-2 commonHeightForCartVariant mobile-display-unit-Price"
                    [ngClass]="!isLast ? 'border-bottom first-child' : ''">
                    <!-- option is Order Entry of Variant Product-->
                    <div class="col-12">
                      <label class="group-type udx-line-clamp">
                        {{ option.product?.name }}
                        <br />
                        <small class="group-type-age-label">{{
                          'pdp.ageGroup.' + option.product?.ageCategory | cxTranslate
                        }}</small>
                      </label>
                    </div>
                    <div class="col-12">
                      <app-item-counter [min]="convertQty(option.product?.minQty!)"
                        [max]="convertQty(option.product?.maxQty!)"
                        [control]="$any(form.get(option.product?.code! + item.variantGroupingCode))"
                        (quantityChanged)="onQuantityChanged($event, item, option)" [readonly]="readonly">
                      </app-item-counter>
                    </div>
                    @if (!readonly) {
                      <div class="col-12">
                      </div>
                    }
                  </div>
                }
              </td>
            } @else {
              <td class="cart-table-td">
                <div class="cx-mobile-header-qty" placement="left" title="{{ 'cartItems.quantityTitle' | cxTranslate }}">
                  {{ 'cartItems.quantity' | cxTranslate }}
                </div>
                <div class="row container cx-header-qty">
                  @if (item.product?.ageCategory) {
                    <div class="col-12">
                      <label class="group-type">
                        {{ item.product?.name }}
                        <br />
                        <small class="group-type-age-label">{{
                          'pdp.ageGroup.' + item.product?.ageCategory | cxTranslate
                        }}</small>
                      </label>
                    </div>
                  }
                  <div class="col-12">
                    <app-item-counter [min]="convertQty(item.product?.minQty!)" [max]="convertQty(item.product?.maxQty!)"
                      [readonly]="readonly"
                      [control]="item.variantGroupingCode ? $any(form.get(item.product?.code! + item.variantGroupingCode)) : $any(form.get(item.product?.code!))"
                      (quantityChanged)="onQuantityChangedNonVariant($event, item)">
                    </app-item-counter>
                  </div>
                  @if (!readonly) {
                    <div class="col-12">
                    </div>
                  }
                </div>
              </td>
            }
            @if (displayTicketID) {
              <td class="cart-table-td">
                <!-- Ticket Numbers -->
                <span style="white-space: pre-line">
                  {{ item.ticketCodesDisplayString }}
                </span>
              </td>
            }
            @if (displayProductUnitPrice) {
              @if (item.variants) {
                <td class="cart-table-td pl-0">
                  <!-- Product Unit Price -->
                  <div class="cx-mobile-header-price inline-padding" placement="left">
                    {{ 'cartItems.productUnitPrice' | cxTranslate }}
                  </div>
                  @for (option of item.variantOptions; track option; let isLast = $last) {
                    <div class="row container mr-0  pr-0 pl-0 mb-2 commonHeightForCartVariant mobile-display-unit-Price"
                      [ngClass]="!isLast ? 'border-bottom first-child' : ''">
                      <div class="col-12 d-table">
                        <span style="white-space: pre-line" class="d-table-cell align-middle">
                          {{ option.product?.price?.formattedValue }}
                        </span>
                      </div>
                    </div>
                  }
                </td>
              } @else {
                <td class="cart-table-td ">
                  <div class="cx-mobile-header-price inline-padding" placement="left">
                    {{ 'cartItems.productUnitPrice' | cxTranslate }}
                  </div>
                  <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant mobile-display">
                    <div class="col-12 d-table">
                      <span style="white-space: pre-line" class="d-table-cell align-middle">
                        {{ item.product?.price?.formattedValue }}
                      </span>
                    </div>
                  </div>
                </td>
              }
            }
            @if (displayProductVariantTotalPrice) {
              @if (item.variants) {
                <td class="cart-table-td pl-0">
                  <!-- Product Unit Price -->
                  <div class="cx-mobile-header-price" placement="left">
                    {{ 'cartItems.productVariantTotalPrice' | cxTranslate }}
                  </div>
                  @for (option of item.variantOptions; track option; let isLast = $last) {
                    <div class="row container mr-0  pr-0 pl-0 mb-2 commonHeightForCartVariant mobile-display-unit-Price"
                      [ngClass]="!isLast ? 'border-bottom first-child' : ''">
                      <div class="col-12 d-table">
                        <span style="white-space: pre-line" class="d-table-cell align-middle">
                          {{ option.totalPrice?.formattedValue }}
                        </span>
                      </div>
                    </div>
                  }
                </td>
              } @else {
                <td class="cart-table-td pl-0">
                  <div class="cx-mobile-header-price" placement="left">
                    {{ 'cartItems.productVariantTotalPrice' | cxTranslate }}
                  </div>
                  <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant mobile-display">
                    <div class="col-12 d-table">
                      <span style="white-space: pre-line" class="d-table-cell align-middle">
                        {{ item.totalPrice?.formattedValue }}
                      </span>
                    </div>
                  </div>
                </td>
              }
            }
            @if (shouldEnableActions()) {
              <td class="cart-table-td">
                @if (shouldEnableDelete()) {
                  <div>
                    <button [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
                      attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
                      class="link cx-action-link cx-remove-btn" (click)="removeEntry(item)">
                      {{ 'common.remove' | cxTranslate }}
                    </button>
                  </div>
                }
              </td>
              <td class="cart-table-td">
                <!-- <ng-container *ngIf="isNotReadonlyInNature()"> -->
                <div>
                  <button class="link cx-action-link cx-remove-btn" (click)="performUpdateEntry(item)">
                    {{ 'common.update' | cxTranslate }}
                  </button>
                </div>
              <!-- </ng-container> -->
            </td>
          }
        </tr>
        <ng-template #totalPrice>
        </ng-template>
      }
    </tbody>
  </table>
}

@else {
<table class="table" style="width: 100%">
  <caption class="cx-visually-hidden">
    {{
    'cartItems.caption' | cxTranslate
    }}
  </caption>
  @if (hasHeader) {
    <thead>
      <tr>
        <!-- <th class="cart-table-th">
        {{ 'cartItems.description' | cxTranslate }}
      </th> -->
      <th class="cart-table-th text-wrap">
        {{ 'cartItems.date' | cxTranslate }}
      </th>
      <th class="cart-table-th text-wrap">
        {{ 'cartItems.quantity' | cxTranslate }}
      </th>
      @if (displayTicketID) {
        <th class="cart-table-th text-wrap">
          {{ 'cartItems.ticketID' | cxTranslate }}
        </th>
      }
      @if (displayProductUnitPrice) {
        <th class="cart-table-th text-wrap">
          {{ 'cartItems.productUnitPrice' | cxTranslate }}
        </th>
      }
      @if (displayProductVariantTotalPrice) {
        <th class="cart-table-th text-wrap">
          {{ 'cartItems.productVariantTotalPrice' | cxTranslate }}
        </th>
      }
      @if (options.isSaveForLater) {
        <th class="cart-table-th text-wrap">
          {{ 'saveForLaterItems.stock' | cxTranslate }}
        </th>
      } @else {
        @if(!UDXshowFields){
          @if (displayTotalPriceColumn) {
            <th class="cart-table-th text-wrap">
              {{ 'cartItems.total' | cxTranslate }}
            </th>
          }
        }
      }
      @if (shouldEnableActions()) {
        <th class="cart-table-th text-wrap">
          {{ 'cartItems.actions' | cxTranslate }}
        </th>
      }
    </tr>
  </thead>
}
<tbody class="app-cart-item-list">
  @for (item of items; track item; let i = $index) {
    <tr>
      <td class="cart-table-td">
        <!-- Date -->
        <div>
          @if (item.selectedDateToVisit) {
            <div class="col">
              @if (!readonly) {
                <label class="label-font-cart">
                  {{ 'pdp.selectVisitationDate' | cxTranslate }}
                </label>
              }
              @if (readonly) {
                {{ item.selectedDateToVisit | dayjsFormat }}
                <!-- <br /> -->
                <!-- Someday: {{ '2025-04-09' | dayjsFormat }} -->
              }
              @if (!readonly) {
                <mat-form-field style="max-width: 150px" appearance="fill">
                  <input
                    matInput
                    [matDatepickerFilter]="dateFilter"
                    [matDatepicker]="dp"
                    [readonly]="true"
                      [formControl]="
                        $any(form).get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-date')
                      "
                    (dateChange)="dateSelected($event, item)"
                    />
                  <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle(item)"></mat-datepicker-toggle>
                  <mat-datepicker #dp [disabled]="readonly"></mat-datepicker>
                </mat-form-field>
                @if (item.isLoadingDates) {
                  <mat-spinner></mat-spinner>
                }
              }
            </div>
          }
          @if (item.selectedTimeSlot) {
            <div class="col">
              @if (!readonly) {
                <label class="label-font-cart">
                  {{ 'pdp.selecttimeslot' | cxTranslate }}
                </label>
              }
              @if (!readonly) {
                <mat-form-field style="max-width: 150px" appearance="fill">
                  <mat-select
                    placeholder="{{ item.selectedTimeSlot }}"
                    (selectionChange)="timeSlotSelected($event, item)"
                      [formControl]="
                        $any(form.get((item.baseProduct ? item.variantGroupingCode : item.product?.code) + '-time'))
                      "
                    name="time"
                    [disabled]="readonly"
                    [value]="getDefaultPerfomance(item.timeSlots)"
                    >
                    @for (time of item.timeSlots; track time) {
                      <mat-option [value]="time">
                        {{ time }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }
        </div>
      </td>
      @if (item.variants) {
        <td style="width:40%" class="cart-table-td">
          <!-- Quantity -->
          @for (option of item.variantOptions; track option; let isLast = $last) {
            <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant" [ngClass]="!isLast ? 'border-bottom' : ''">
              <!-- option is Order Entry of Variant Product-->
              <div class="col-12 d-table">
                <span class="align-middle d-table-cell">
                  {{ option.product?.name }}
                  <small class="group-type-age-label">{{
                    'pdp.ageGroup.' + option.product?.ageCategory | cxTranslate
                  }} {{ form.get(option.product?.code! + item.variantGroupingCode)?.getRawValue() }} {{ 'cartItems.tickets' | cxTranslate}}</small>
                </span>
              </div>
              @if (!readonly) {
                <div class="col-12">
                  <small class="group-type-age-label">
                    @if (option.product?.minQty) {
                      <b>{{
                        'common.productMinVal' | cxTranslate : { minVal: option.product?.minQty }
                      }}</b>
                    }
                    @if (option.product?.minQty && option.product?.maxQty) {
                      <b>, </b>
                    }
                    @if (option.product?.maxQty) {
                      <b>{{
                        'common.productMaxVal' | cxTranslate : { maxVal: option.product?.maxQty }
                      }}</b>
                    }
                  </small>
                </div>
              }
            </div>
          }
        </td>
      } @else {
        <td style="width:40%" class="cart-table-td">
          <div class="row container m-2 mt-4">
            @if (item.product?.ageCategory) {
              <div class="col-12">
                <label class="group-type">
                  {{ item.product?.name }}
                  <small class="group-type-age-label">{{
                    'pdp.ageGroup.' + item.product?.ageCategory | cxTranslate
                  }} {{ form.get(item.product?.code! + item.variantGroupingCode)?.getRawValue() }} {{ 'cartItems.tickets' | cxTranslate}}</small>
                </label>
              </div>
            }
            @if (!readonly) {
              <div class="col-12">
                <small class="group-type-age-label">
                  @if (item.product?.minQty) {
                    <b>{{
                      'common.productMinVal' | cxTranslate : { minVal: item.product?.minQty }
                    }}</b>
                  }
                  @if (item.product?.minQty && item.product?.maxQty) {
                    <b>, </b>
                  }
                  @if (item.product?.maxQty) {
                    <b>{{
                      'common.productMaxVal' | cxTranslate : { maxVal: item.product?.maxQty }
                    }}</b>
                  }
                </small>
              </div>
            }
          </div>
          @if (item.product?.attractions?.events?.length) {
            <div style="text-align: left !important;">
              <!-- <li *ngFor="let event of item.product?.attractions?.events" style="text-align: left; list-style-position: outside;">
              <div style="display: inline; white-space: pre-wrap;">
                <ng-container *ngIf="event.maingroup === 'TIMED'">
                  {{ event.landEntry ? event.landEntryDisplayText : event.selectionFromTime + ' - ' + event.selectionToTime }}:
                </ng-container>
                {{ event.eventName }}
              </div>
            </li> -->
            <!-- this.getEventsGroupedByMainGroup(item.product?.attractions?.events!): {{ this.getEventsGroupedByMainGroup(item.product?.attractions?.events!) | json }} -->
            @for (eventsByGroup of this.getEventsGroupedByMainGroup(this.sortEventsByStartTimeAndLandEntry(item.product?.attractions?.events!)); track eventsByGroup) {
              @if (eventsByGroup[0].maingroup === 'TIMED') {
                @for (aTimedEvent of eventsByGroup; track aTimedEvent) {
                  <!-- <li style="text-align: left; list-style-position: outside;"> -->
                  {{ aTimedEvent.landEntry ? aTimedEvent.landEntryDisplayText : aTimedEvent.selectionFromTime + ' ~ ' + aTimedEvent.selectionToTime }}:
                  {{ aTimedEvent.eventName }}
                  <br/>
                <!-- </li> -->
              }
            }
            @if (eventsByGroup[0].maingroup === 'NON_TIMED') {
              <!-- eventsByGroup[0].maingroup === 'NON-TIMED': {{ eventsByGroup | json }} -->
              <!-- this.getEventsGroupedBySubGroup(eventsByGroup): {{ this.getEventsGroupedBySubGroup(eventsByGroup) | json }} -->
              <ul class="ps-3">
                @for (eventsBySubgroup of this.getEventsGroupedBySubGroup(eventsByGroup); track eventsBySubgroup) {
                  <!-- eventsByGroup: {{ eventsByGroup | json }}: -->
                  <!-- <br/>  -->
                  <!-- <ng-container *ngIf="isAttractionGroupChoice(eventsBySubgroup)">
                  <div class="col-12 text-left">
                    {{ 'pdp.choiceAttractions.'+getOnlyChoiceText(eventsBySubgroup) | cxTranslate }}
                    <br/>
                    {{ 'pdp.choiceAttractionsHelpText' | cxTranslate }}
                  </div>
                </ng-container> -->
                <!-- <ul class="ps-3"> -->
                <li style="text-align: left; list-style-position: outside;">
                  @for (anEventInSubgroup of eventsBySubgroup; track anEventInSubgroup; let i = $index; let last = $last) {
                    {{ anEventInSubgroup.eventName }}
                    @if (!last) {
                      &nbsp;{{'common.choiceSeparatorText' | cxTranslate}}&nbsp;
                    }
                    @if (last && eventsBySubgroup.length>1) {
                      &nbsp;{{'common.choiceEitherOne' | cxTranslate}}&nbsp;
                    }
                  }
                </li>
              <!-- </ul> -->
            }
          </ul>
        }
      }
    </div>
  }
</td>
}
@if (displayTicketID) {
  <td class="cart-table-td">
    <!-- Ticket Numbers -->
    <span style="white-space: pre-line">
      {{ item.ticketCodesDisplayString }}
    </span>
  </td>
}
@if (displayProductUnitPrice) {
  @if (item.variants) {
    <td class="cart-table-td pl-0">
      <!-- Product Unit Price -->
      @for (option of item.variantOptions; track option; let isLast = $last) {
        <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant" [ngClass]="!isLast ? 'border-bottom' : ''">
          <div class="col-12 d-table">
            <span style="white-space: pre-line" class="d-table-cell align-middle">
              {{ option.product?.price?.formattedValue }}
            </span>
          </div>
        </div>
      }
    </td>
  } @else {
    <td class="cart-table-td pl-0">
      <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant">
        <div class="col-12 d-table">
          <span style="white-space: pre-line" class="d-table-cell align-middle">
            {{ item.product?.price?.formattedValue }}
          </span>
        </div>
      </div>
    </td>
  }
}
@if (displayProductVariantTotalPrice) {
  @if (item.variants) {
    <td class="cart-table-td pl-0">
      <!-- Product Unit Price -->
      @for (option of item.variantOptions; track option; let isLast = $last) {
        <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant" [ngClass]="!isLast ? 'border-bottom' : ''">
          <div class="col-12 d-table">
            <span style="white-space: pre-line" class="d-table-cell align-middle">
              {{ option.totalPrice?.formattedValue }}
            </span>
          </div>
        </div>
      }
    </td>
  } @else {
    <td class="cart-table-td pl-0">
      <div class="row container mr-0 ml-0 pr-0 pl-0 mb-2 commonHeightForCartVariant">
        <div class="col-12 d-table">
          <span style="white-space: pre-line" class="d-table-cell align-middle">
            {{ item.totalPrice?.formattedValue }}
          </span>
        </div>
      </div>
    </td>
  }
}
@if (displayTotalPriceColumn) {
  @if (item.combinedVariantPrice | async; as resolvedPrice) {
    <td class="cart-table-td">
      <div>{{ resolvedPrice | currency: 'JPY' }}</div>
    </td>
  } @else {
    <td class="cart-table-td">
      <div>
        {{ item.totalPrice?.formattedValue }}
      </div>
    </td>
  }
}
@if (shouldEnableActions()) {
  <td class="cart-table-td">
    @if (shouldEnableDelete()) {
      <div>
        <button
          [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
          attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
          class="link cx-action-link cx-remove-btn"
          (click)="removeEntry(item)"
          >
          {{ 'common.deleteInCartItem' | cxTranslate }}
        </button>
      </div>
    }
    @if (isNotReadonlyInNature()) {
      <div>
        <button
          class="link cx-action-link cx-remove-btn"
          [disabled]="!item.shouldEnableUpdate"
          (click)="performUpdateEntry(item)"
          >
          {{ 'common.update' | cxTranslate }}
        </button>
      </div>
    }
  </td>
}
</tr>
}
</tbody>
</table>

}
<br />
</form>
